<template>
  <div class="container">
    <!-- 导航菜单栏 -->
    <nav-bar></nav-bar>
    <!-- 头部区域 -->
    <head-bar></head-bar>
    <!-- 主内容区域 -->
    <main-content></main-content>
  </div>
</template>

<script>
import HeadBar from "./HeadBar"
import NavBar from "./NavBar"
import MainContent from "./MainContent"
export default {
  components: {
    HeadBar,
    NavBar,
    MainContent
  },
  created() {
    console.log('Store::::', this.$store)
    this.$store.commit('GET_USER', this);
    // 初始化 全局属性
    this.$store.dispatch('getAllSchoolList');
    this.freshBrower();
  },
  methods: {
    // initUser() {
    //   const user_ = sessionStorage.getItem('userinfo');
    //   if (user_) {
    //     this.$store.commit('SET_USER', JSON.parse(user_));
    //   } else {
    //     this.$router.push('/login');
    //   }
    // },
    freshBrower() {
      // 刷新浏览器, 初始化数据
      this.$store.commit('GET_USER', this);
      const {userCenterInfo} = this.user;
      if (userCenterInfo && userCenterInfo.platformSso.length) {
        console.log('>>>>>>>>>>><<<<<<<<<<<<<<<')
        const { userId, loginRecord } = userCenterInfo;
        this.$$utils.serviceUtil.startUserCenterHeartBeat({ userId, loginRecord, type: 'now' });
      }
    },
  }
};
</script>

<style scoped lang="scss">
.container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  // background: rgba(224, 234, 235, 0.1);
}
</style>  


// WEBPACK FOOTER //
// src/views/Home.vue